import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

type Props = DialogProps & {
  onExclude: () => void;
  selectedOrdersAmount: number;
};

export const OrderAdjustmentsExcludeGroupDialog = ({
  open,
  onClose,
  onExclude,
  selectedOrdersAmount,
}: Props) => {
  const translate = useTypedTranslate();

  return (
    <Dialog maxWidth="sm" onClose={onClose} open={open}>
      <CardHeader
        appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
        sx={{ '& .MuiTypography-root': { width: '70%' } }}
        title={translate('app.orderAdjustments.excludeGroupDialog.title')}
        titleSize="smallBold"
      />
      <CardContent>
        <Typography>
          {translate('app.orderAdjustments.excludeGroupDialog.message', { selectedOrdersAmount })}
        </Typography>
      </CardContent>
      <CardActionsButtons
        rightActionsSlot={[
          <CancelButton
            key="cancel-button"
            label={translate('app.orderAdjustments.excludeGroupDialog.cancel')}
            onClick={onClose}
            variant="outlined"
          />,
          <Button
            color="error"
            key="save-button"
            label={translate('app.orderAdjustments.excludeGroupDialog.confirm')}
            onClick={onExclude}
            variant="contained"
          />,
        ]}
      />
    </Dialog>
  );
};
